import { getSubdomain } from "./EnvHelper";

const placeholder = '[$oli-sub-domain$]';

function isStringWithData(text) {
  if (typeof text === 'string' || text instanceof String) {
    return text.length > 0;
  }
  return false;
}

function replaceDomain(domain, subdomain) {
  if (subdomain === "dev.") {
    subdomain = "";
  }
  if (!domain.replaceAll) {
    return domain.split(placeholder).join(subdomain);
  }
  return domain.replaceAll(placeholder, subdomain);
}

export default function resolveSubDomain(domain, subdomain = getSubdomain()) {
  console.log("resolve sub domain!");
  if (isStringWithData(domain) && domain.length >= placeholder.length) {
    let useSub = subdomain.trim();
    console.log("using: " + useSub);
    if (!isStringWithData(useSub)) {
      useSub = '';
    }
    return replaceDomain(domain, useSub);
  }
  return domain;
}